import { useRef, useEffect } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface PrettyCodeProps {
  code: string;
  language: string;
  highlightLine?: number;
}

const PrettyCode: React.FC<PrettyCodeProps> = ({ code, language, highlightLine = -1 }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (highlightLine > 0 && containerRef.current) {
      const el = containerRef.current.querySelector(`#line-${highlightLine}`) as HTMLElement | null;
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [highlightLine]);

  const lineProps = (lineNumber: number) => {
    const isTarget = lineNumber === highlightLine;
    return {
      style: {
        display: 'block',
        backgroundColor: isTarget ? 'rgba(255, 235, 59, 0.3)' : undefined,
      },
      id: isTarget ? `line-${lineNumber}` : undefined,
    };
  };

  return (
    <div ref={containerRef} style={{ maxHeight: 300, overflowY: 'auto', position: 'relative' }}>
      <SyntaxHighlighter
        language={language}
        style={oneLight}
        wrapLongLines
        showLineNumbers
        wrapLines
        lineProps={lineProps}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};

export default PrettyCode;
